export default "<div [class]=\"mediator.activeTheme.themeClass\" [style.height.%]=\"100\">\n  <router-outlet></router-outlet>\n</div>\n"